import { Request } from '../../Servidor/Request';

export class ItensToInspectRequest {
    private sgepitensinspecaodengue: number;
    private nome: string
    private codigo: string;

    constructor(sgepitensinspecaodengue: number, codigo: string, nome: string) {
        this.sgepitensinspecaodengue = sgepitensinspecaodengue;
        this.codigo = codigo;
        this.nome = nome;
    }


    /**
     * Getter sgepitensinspecaodengue
     * @return {number}
     */
    public getSgepItensInspecaoDengue(): number {
        return this.sgepitensinspecaodengue;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class ItensToInspectStructRequest {
    private sgepitensinspecaodengue: number;

    constructor(sgepitensinspecaodengue: number) {
        this.sgepitensinspecaodengue = sgepitensinspecaodengue;
    }


    /**
     * Getter sgepitensinspecaodengue
     * @return {number}
     */
    public getSgepItensInspecaoDengue(): number {
        return this.sgepitensinspecaodengue;
    }

}

export class ItensToInspectStructResponse {
    private sgepitensinspecaodengue: number;
    private codigo: string;

    constructor(sgepitensinspecaodengue: number, codigo: string) {
        this.sgepitensinspecaodengue = sgepitensinspecaodengue;
        this.codigo = codigo;
    }


    /**
     * Getter sgepitensinspecaodengue
     * @return {number}
     */
    public getSgepItensInspecaoDengue(): number {
        return this.sgepitensinspecaodengue;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class ItensToInspectInteractor {
    public fetchSave(request: ItensToInspectRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/itens-inspecao/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: ItensToInspectStructRequest): PromiseLike<ItensToInspectStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/itens-inspecao/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}